<div [formGroup]="parent"
    [ngClass]="[((parent.get(controllerData.controlName).touched
        && parent.get(controllerData.controlName).errors)?'has-error':''),
        (componentName === 'yourOptions')?'form-field form-field-margin-0':
        ((componentName === 'yourPesionSavings')?'form-field form-field-apply':'form-field'),
        (parent.get(controllerData.controlName).touched && parent.get(controllerData.controlName).errors && componentName === 'yourOptions')? 'margin-top-30':'']">

    <span [ngClass]="{'font-color-red': parent.get(controllerData.controlName).errors 
        && parent.get(controllerData.controlName).touched
        && (parent.get(controllerData.controlName).errors.required || 
        parent.get(controllerData.controlName).errors.invalidMaturity)}"
  class="currency-symbol" id="currency-symbol">£</span>
  <label [id]="'lbl-'+controllerData['name']" class="visuallyhidden">{{controllerData['name']}}</label>
    <input class="form-control" appCurrency DecimalPlaces="2" [attr.aria-required]="true" [attr.aria-invalid]="(parent.get(controllerData.controlName).errors 
        && parent.get(controllerData.controlName).touched
        && (parent.get(controllerData.controlName).errors.required || 
        parent.get(controllerData.controlName).errors.invalidMaturity)) ? true : false" aria-label="appCurrency field"
    [min]="controllerData['minValue']" [max]="controllerData['maxValue']"
    [formControlName]="controllerData['controlName']" [id]="controllerData['name']"
    [(ngModel)]="controllerData.value" [name]="controllerData['name']" [placeholder]="controllerData['placeHolder']"
    autocomplete="off" (input)="currencyChangeHandler($event.target.value)" (keyup.enter)="validateInput()"
    (blur)="validateInput()" [ngClass]="{'size':router.url === '/quote/your-product-options'}" inputmode="numeric">
    @if (controllerData.title) {
      <i class="currency-text"
      [id]="controllerData['name']+'-value'">{{controllerData.titleValue}}%</i>
    }
    @if (controllerData.infoIconFlag) {
      <app-tool-tip-notification [childId]="sliderId" [tooltipName]="controlName+'_tooltip'"
        class="col-sm-1 info-icon"
        [tooltipData]="controllerData.infoIconData"
      (displayMobileTooltipEmitter)="displayMobileTooltipSliderReceiver()"></app-tool-tip-notification>
    }
  </div>
  @if (parent.get(controllerData.controlName).touched
    &&
    parent.get(controllerData.controlName).errors
    &&
    !parent.get(controllerData.controlName).errors.emptyFund) {
    <div [id]="controllerData['controlName']+'-error'" class="form-validation-error">
      <i class="icon icon-error" aria-hidden="true"></i>
      @if (parent.get(controllerData.controlName).errors.required) {
        <p id="currency-error" aria-hidden="false"
        role="error">{{controllerData['errorMessage']}}</p>
      }
      @if (parent.get(controllerData.controlName).errors.invalidMaturity) {
        <p id="currency-error" aria-hidden="false"
        role="error">{{controllerData['customErrorMessage1']}}</p>
      }
      @if (parent.get(controllerData.controlName).errors.invalidTaxfree) {
        <p id="currency-error" aria-hidden="false"
        role="error">{{invalidTaxfree(controllerData.invalidTaxfreeMessage)}}</p>
      }
      @if (parent.get(controllerData.controlName).errors.invalidPTFCTaxfree) {
        <p id="currency-error" aria-hidden="false"
        role="error">{{invalidPTFCTaxfree(controllerData.invalidTaxfreeMessage)}}</p>
      }
      @if (parent.get(controllerData.controlName).errors.invalidLTAMin) {
        <p id="currency-error" aria-hidden="false"
        role="error">{{setMinLTA(controllerData.invalidLTAMinMsg)}}</p>
      }
    </div>
  }